import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  getNextNickTime,
  nickCar,
} from "@/helper/contractFunctions/MafiaCarNick";

export interface NickCarState {
  isNickingCar: boolean;
  nextNickTime: number;
}

const initialState: NickCarState = {
  isNickingCar: false,
  nextNickTime: -1,
};

export const nickCarAction = createAsyncThunk(
  "nickCar/nickCarAction",
  async ({
    account,
    crimeType,
    signMsg,
    signature,
  }: {
    account: string;
    crimeType: number;
    signMsg: string;
    signature: string;
  }) => nickCar(crimeType, account, signMsg, signature)
);

export const getNextNickCarAction = createAsyncThunk(
  "nickCar/getNextNickCarAction",
  getNextNickTime
);

const nickCarSlice = createSlice({
  name: "nickCar",
  initialState,
  reducers: {
    finishNick: (state) => {
      state.isNickingCar = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNextNickCarAction.fulfilled, (state, { payload }) => {
        state.nextNickTime = payload;
      })
      .addCase(getNextNickCarAction.rejected, (state) => {
        state.nextNickTime = -1;
      })
      .addCase(nickCarAction.pending, (state) => {
        state.isNickingCar = true;
      })
      .addCase(nickCarAction.fulfilled, (state) => {
        state.isNickingCar = false;
      })
      .addCase(nickCarAction.rejected, (state, { error }) => {
        state.isNickingCar = false;
        console.log(error);
      });
  },
});

export const { finishNick } = nickCarSlice.actions;
export default nickCarSlice.reducer;
